import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-footer-two',
  templateUrl: './footer-two.component.html',
  styleUrls: ['./footer-two.component.scss']
})
export class FooterTwoComponent implements OnInit {

  @Input() class: string;
  // @Input() themeLogo: string ='https://izzimoviles.s3.us-east-1.amazonaws.com/Imagenes/GIGMAX_WHITE.png'; // Default Logo
  @Input() themeLogo: string = 'assets/images/icon/'; //'assets/images/icon/logo_bt_white.png'; // Default Logo
  @Input() mainFooter: boolean = true; // Default true 
  @Input() subFooter: boolean = false; // Default false 
  
  public today: number = Date.now();
  
  constructor() { }

  ngOnInit(): void {
  }

}
